exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-profile {\n  transition: all 0.3s ease-in-out;\n}\n.blurImage {\n  filter: blur(10px);\n}", ""]);

// exports
